import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Flag = forwardRef<SVGSVGElement, SvgIconProps>(function Flag(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="m17.257374,5.961495c-0.12953,-0.10757 -0.30709,-0.1232 -0.46886,-0.10757l-1.16457,0.27705c-1.18101,0.27704 -2.44297,0.21513 -3.60752,-0.1845l-0.01643,0c-1.26189,-0.4459 -2.62042,-0.53846 -3.91454,-0.29206l-0.45307,0.09255l0,-0.13942c0,-0.29207 -0.24265,-0.53847 -0.56618,-0.53847c-0.32353,0 -0.56617,0.23077 -0.56617,0.53847l0,12.78492c0,0.29206 0.24264,0.53846 0.56617,0.53846c0.32353,0 0.56618,-0.23077 0.56618,-0.53846l0,-5.61539l0.64706,-0.12319c1.11592,-0.21514 2.2647,-0.1232 3.31617,0.26141l0.04866,0.01563c0.80882,0.27704 1.64984,0.43089 2.50735,0.43089c0.58262,0 1.18102,-0.0613 1.76291,-0.21514l1.16458,-0.27704c0.24265,-0.0613 0.42085,-0.27705 0.42085,-0.50782l0,-5.96938c-0.01643,-0.16948 -0.11311,-0.32333 -0.24265,-0.4309l0.00006,-0.00004z" />
    </SvgIcon>
  )
})

export default Flag
